import React from "react";
import PropertyLikeButton from "@/components/common/property-like-button/property-like-button";
import { useLikesDrawer } from "@/components/common/likes-drawer/likes-drawer-context";
import useCommentLike from "@/hooks/useCommentLike";
import type { MixpanelLikeUnlikeLocation } from "@/constants/mixpanel.constants";

interface CommentLikeControlProps {
    commentId: string;
    playablePropertyId?: string;
    authorNickname: string;
    initialLikeCount: number;
    initialLikedByCurrentUser: boolean;
    userId: string | null;
    isUserAuthenticated: boolean;
    onRequireAuth: () => void;
    mixpanelLocation?: MixpanelLikeUnlikeLocation;
}

/**
 * Heart + count for a single scoreboard comment row.
 */
const CommentLikeControl: React.FC<CommentLikeControlProps> = ({
    commentId,
    playablePropertyId,
    authorNickname,
    initialLikeCount,
    initialLikedByCurrentUser,
    userId,
    isUserAuthenticated,
    onRequireAuth,
    mixpanelLocation = "Scoreboard",
}) => {
    const { openLikesDrawer } = useLikesDrawer();
    const { isLiked, likeCount, isPending, toggleLike } = useCommentLike({
        commentId,
        playablePropertyId,
        initialLikeCount,
        initialLikedByCurrentUser,
        userId,
        isAuthenticated: isUserAuthenticated,
        onRequireAuth,
        nicknameLiked: authorNickname,
        mixpanelLocation,
    });
    return (
        <PropertyLikeButton
            variant="scoreboard"
            isLiked={isLiked}
            likeCount={likeCount}
            isDisabled={isPending}
            ariaLabel={isLiked ? "Unlike comment" : "Like comment"}
            onClick={(event) => {
                event.stopPropagation();
                toggleLike();
            }}
            onCountClick={(event) => {
                event.stopPropagation();
                openLikesDrawer({
                    contentType: "comment",
                    contentId: commentId,
                    likeCount,
                    location: "Scoreboard",
                });
            }}
        />
    );
};

export default CommentLikeControl;
